import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import { BASE_URI } from '../Config';

const SendVerificationEmail: React.FC = () => {
    const [message, setMessage] = useState<string | null>(null);
    const { userEmail, userToken } = useAuth();


    const sendVerification = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const response = await fetch(`${BASE_URI}/send_verification_email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`
                },
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            if (data.success) {
                setMessage('Verification email sent successfully!');
            } else {
                setMessage(data.message);
            }
        } catch (error) {
            console.error("Error sending verification email:", error);
            setMessage('Error occurred while sending verification email. Please try again.');
        }
    };

    return (
        <div>
            <form onSubmit={sendVerification}>
                <h3>Verify email</h3>
                {!message && <p>Please verify your account by clicking on the link sent to <i>{userEmail}</i>.</p>}
                {!message && <input type="submit" value="Resend"></input>}
                {message && <p>{message}</p>}
            </form>
            
        </div>
    );
};

export default SendVerificationEmail;